<section class="top pt-5 pb-3">
  <div class="container">
    <h1>{{ 'Forside.Top.Overskrift' | tekstresource }}</h1>
    <p class="h2">
      <Strong>{{ 'Forside.Top.Underoverskrift' | tekstresource }}</Strong>
    </p>
    <p [innerHtml]="'Forside.Top.Beskrivelse' | tekstresource"></p>
  </div>
</section>
<section class="anskaf-raadgiver pt-6">
  <div class="container">
    <div class="row px-5 pt-4 shadow">
      <div class="col">
        <div class="row">
          <h2>{{ 'Forside.AnskafRaadgiver.Tekst' | tekstresource }}</h2>
          <p class="row row2020">
            {{ 'Forside.AnskafRaadgiver.Tekst.Ny2020Regel' | tekstresource }}
          </p>
        </div>
      </div>
      <div class="col col-auto">
        <a [routerLink]="['/hjaelp', 'inden-du-ansoeger']" class="button button-tertiary">
          {{ 'Forside.AnskafRaadgiver.KnapTekst' | tekstresource }}
        </a>
      </div>
    </div>
  </div>
</section>

<section class="cards py-6">
  <div class="container">
    <div class="row">
      <div class="col mr-4">
        <ng-container *ngTemplateOutlet="card; context: card1"></ng-container>
      </div>
      <div class="col mx-4 lighter1">
        <ng-container *ngTemplateOutlet="card; context: card2"></ng-container>
      </div>
      <div class="col ml-4 lighter2">
        <ng-container *ngTemplateOutlet="card; context: card3"></ng-container>
      </div>
    </div>
  </div>
</section>
<section class="video py-7">
  <div class="container">
    <h2>{{ 'Forside.AnskafRaadgiver.Tekst' | tekstresource }}</h2>
    <div class="row">
      <div class="col">
        <div class="video-container">
          <bom-video
            videoId="347245497"
            width="828"
            height="432"
            imageUrl="assets/img/video/BOM_video_thumbnail.jpg"
          ></bom-video>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="hjaelp py-7">
  <div class="container">
    <h2>{{ 'Forside.Hjaelp.Overskrift' | tekstresource }}</h2>
    <div class="row mb-5">
      <div class="col mr-4">
        <a [routerLink]="['/hjaelp', 'byggeansoegning-undgaa-fejl', 'husk-altid-fuldmagten']">
          <img
            src="assets/img/forside/BOM-Frontpage4x1_Husk_at_medsende_fuldmagt_fra_alle_ejere.jpg"
            alt="Hånd der underskriver"
          />
          <h3 class="mt-0">{{ 'Forside.Hjaelp.Fuldmagt' | tekstresource }}</h3>
        </a>
      </div>
      <div class="col mx-4">
        <a [routerLink]="['/hjaelp', 'byggeansoegning-undgaa-fejl', 'brandklasse']">
          <img
            src="assets/img/forside/BOM-Frontpage4x1_Brand-konstruktionsklasse.jpg"
            alt="Person der inspicerer vægkonstruktion"
          />
          <h3 class="mt-0">{{ 'Forside.Hjaelp.Brandklasse' | tekstresource }}</h3>
        </a>
      </div>
      <div class="col mx-4">
        <a [routerLink]="['/hjaelp', 'byggeansoegning-undgaa-fejl', 'tekniske-forhold']">
          <img
            src="assets/img/forside/BOM-Frontpage4x1_Tekniske_forhold_bygningsreglementet.jpg"
            alt="Bygningsreglementet"
          />
          <h3 class="mt-0">{{ 'Forside.Hjaelp.TekniskeForhold' | tekstresource }}</h3>
        </a>
      </div>
      <div class="col ml-4">
        <a [routerLink]="['/hjaelp', 'eksempler-paa-tegningsmateriale']">
          <img
            src="assets/img/forside/BOM-Frontpage4x1_Tegningsmateriale.jpg"
            alt="Tegningsmateriale"
          />
          <h3 class="h5 mt-0">{{ 'Forside.Hjaelp.Tegningsmateriale' | tekstresource }}</h3>
        </a>
      </div>
    </div>
    <a class="button button-secondary" [routerLink]="['/hjaelp']"
      >Gå til hjælpesiden og find mere hjælp</a
    >
  </div>
</section>

<ng-template
  #card
  let-title="title"
  let-description="description"
  let-imgsrc="imgsrc"
  let-imgalt="imgalt"
  let-buttontext="buttontext"
  let-routerlink="routerlink"
>
  <div class="bom-card h-100 shadow">
    <img [src]="imgsrc" [alt]="imgalt" />
    <div class="px-5 pt-4">
      <h2>{{ title }}</h2>
      <p>
        {{ description }}
      </p>
    </div>
    <div class="mt-auto px-5 pb-5">
      <a [routerLink]="routerlink" class="button button-tertiary">{{ buttontext }}</a>
    </div>
  </div>
</ng-template>
